import EmailSignupForm from './email-signup-form'

export default EmailSignupForm
